module.exports = __webpack_public_path__ + "img/edit_task.93ab4e3d.svg";